import { DialogActions } from '@mui/material';
import React, { Dispatch, useMemo } from 'react';
import CtaButton from '../../_parts/CtaButton';
import { vars } from '../../../../../Theme';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';
import {
    getCurrentTabsReleaseData,
    getFinalLevelReleaseOptions,
    getReleaseDocuments,
    getReleaseTabs,
    getTotalReleaseDocuments,
    onConfirmInitialRelease,
    onNextInitialRelease,
} from '../../../../../redux/project/sliceProjectWorkflow';
import { useTranslation } from 'react-i18next';
import {
    InitialRelaseState,
    StateChangedArgumentsInitialRelease,
} from '../InitialReleaseDialog/InitialReleaseDialog';
import { useParams } from 'react-router-dom';

export default ({
    isQualityGateStep,
    setIsQualityGateStep,
    mainState,
    setHasError,
    getStateChanged,
}: IReleaseFooterActionsProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'initialReleaseDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();

    const { replicaId } = useParams();

    const { selectedReleaseTab: selectedTab, loading: isLoading } = useSelector(
        (_store: IAppReduxStore) => _store.projectWorkflow,
    );

    const documents = useSelector(getReleaseDocuments);
    const tabs = useSelector(getReleaseTabs);
    const releaseData = useSelector(getCurrentTabsReleaseData);
    const finalLevelOptions = useSelector(getFinalLevelReleaseOptions);

    const tabName = useMemo(() => tabs[selectedTab]?.key, [selectedTab]);

    const totalReleaseDocuments = useSelector(getTotalReleaseDocuments);

    const handleRelease = () => {
        if (tabs[selectedTab].isDisabled) {
            getStateChanged({
                parentValue: tabs[selectedTab].key,
                state: 'placeholder',
            });
            totalReleaseDocuments &&
                dispatch(onConfirmInitialRelease({ pathes: mainState, replicaId }));
        } else if (
            isNestedLevelUnselected() ||
            (mainState[tabName] === undefined && releaseData.length !== 0 && documents.length > 0)
        ) {
            setHasError(true);
        } else {
            dispatch(onConfirmInitialRelease({ pathes: mainState, replicaId }));
        }
    };

    const handleOnNext = () => {
        if (tabs[selectedTab].isDisabled) {
            getStateChanged({
                parentValue: tabs[selectedTab].key,
                state: 'placeholder',
            });
            dispatch(onNextInitialRelease());
        } else if (mainState[tabName] === undefined) {
            setHasError(true);
        } else {
            dispatch(onNextInitialRelease());
        }
    };

    const isNestedLevelUnselected = () => {
        return !finalLevelOptions.find(option => option.path === mainState[tabName]);
    };

    const batchesActionButton = (
        <>
            {selectedTab === tabs.length - 1 ? (
                <CtaButton
                    variant='contained'
                    text={t('release')}
                    onClick={() => handleRelease()}
                    disabled={isLoading || totalReleaseDocuments === 0}
                />
            ) : (
                <CtaButton
                    variant='contained'
                    text={t('sendToWorkflow')}
                    onClick={() => handleOnNext()}
                    disabled={isLoading}
                />
            )}
        </>
    );
    return (
        <DialogActions sx={{ px: 3, py: 1, borderTop: `1px solid ${vars.lightGray}` }}>
            {isQualityGateStep ? (
                <CtaButton
                    variant='contained'
                    text={t('continue')}
                    onClick={() => setIsQualityGateStep(false)}
                    disabled={isLoading || totalReleaseDocuments === 0}
                />
            ) : (
                batchesActionButton
            )}
        </DialogActions>
    );
};

interface IReleaseFooterActionsProps {
    isQualityGateStep: boolean;
    setIsQualityGateStep: (value: boolean) => void;
    mainState: InitialRelaseState;
    setHasError: (value: boolean) => void;
    getStateChanged: (params: StateChangedArgumentsInitialRelease) => void;
}
